import { Injectable } from "@angular/core";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { coreMobileEn } from "../../i18n/core-mobile-en";
import { coreMobilePt } from "../../i18n/core-mobile-pt";
import { coreMobileEs } from "../../i18n/core-mobile-es";

@Injectable()
export class TotvsTranslateProvider {

    constructor() {
    }

    private i18n: any;
    private language: string;

    //PUBLICOS
    public initialize(lang?:string) {

        this.language = lang ? lang : window.navigator.language;
        this.i18n = {};
        this.i18n["PT-BR"] = coreMobilePt;
        this.i18n["ES-ES"] = coreMobileEs;
        this.i18n["EN-US"] = coreMobileEn;

    };

    public initializeWithJson(json?:any) {

        this.i18n = {};
        this.i18n = json;
        
    };

    public instant(message: string) {

        if (!this.i18n)
            this.initialize();
       
        return this.findMessage(message);
    };

    public get(keys: string | Array<string>, _component: string, interpolateParams?: Object) {

        let retorno: any = {};
        let translatedKey: string = "";
        let paramsFromTranslatedKey: string = "";

        if (!(typeof keys === 'string')) {
            for (let key in <Array<string>>keys) {
                translatedKey = this.instant(keys[key]);
                paramsFromTranslatedKey = this.getFromBetween.get(translatedKey, "{{", "}}");
                translatedKey = this.fillParameters(paramsFromTranslatedKey, translatedKey, interpolateParams)
                retorno[keys[key]] = translatedKey;
            }

            return retorno;

        } else {
            translatedKey = this.instant(String(keys));
            paramsFromTranslatedKey = this.getFromBetween.get(translatedKey, "{{", "}}");
            translatedKey = this.fillParameters(paramsFromTranslatedKey, translatedKey, interpolateParams)

            return translatedKey;
        }

    };

    //PRIVADOS
    private findMessage(_message: string) {

        try {
            if (undefined != this.i18n && null != this.i18n) {

                let msg: any = this.i18n[this.language.toUpperCase()];

                let split: any = String(_message).split(".")

                for (let m in split) {
                    if (undefined != msg[split[m]] && null != msg[split[m]])
                        msg = msg[split[m]];
                    else
                        msg = _message;
                }

                return msg
            }
        }
        catch (e) {
            return _message
        }

    };

    private getFromBetween = {
        results: [],
        string: "",
        getFromBetween: function (sub1, sub2) {
            if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
            var SP = this.string.indexOf(sub1) + sub1.length;
            var string1 = this.string.substr(0, SP);
            var string2 = this.string.substr(SP);
            var TP = string1.length + string2.indexOf(sub2);
            return this.string.substring(SP, TP);
        },
        removeFromBetween: function (sub1, sub2) {
            if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
            var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
            this.string = this.string.replace(removal, "");
        },
        getAllResults: function (sub1, sub2) {
            // first check to see if we do have both substrings
            if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

            // find one result
            var result = this.getFromBetween(sub1, sub2);
            // push it to the results array
            this.results.push(result);
            // remove the most recently found one from the string
            this.removeFromBetween(sub1, sub2);

            // if there's more substrings
            if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
                this.getAllResults(sub1, sub2);
            }
            else return;
        },
        get: function (string, sub1, sub2) {
            this.results = [];
            this.string = string;
            this.getAllResults(sub1, sub2);
            return this.results;
        }
    };

    private fillParameters(paramsFromTranslatedKey: string, translatedKey: string, interpolateParams?: Object) {

        for (let paramFromTranslatedKey of paramsFromTranslatedKey) {

            let valueFromParamFromTranslatedKey: string = paramFromTranslatedKey;

            if (null != interpolateParams && undefined != interpolateParams && interpolateParams.hasOwnProperty(paramFromTranslatedKey))
                valueFromParamFromTranslatedKey = interpolateParams[paramFromTranslatedKey];

            translatedKey = translatedKey.replace("{{" + paramFromTranslatedKey + "}}", this.instant(valueFromParamFromTranslatedKey));

        }

        return translatedKey;
    };

}